import { useState } from "react";
import { Box, Typography, Collapse, Button, Card, Avatar } from "@mui/material";

const CollapsiblePermissionList = ({ updatedPermission, downloadUrl, avatarPlaceholder }) => {
  const [expanded, setExpanded] = useState(false);
  const visibleItems = 1;

  return (
    updatedPermission && updatedPermission.length ? <Box>
      {updatedPermission.slice(0, visibleItems).map((item, index) => (
        <Box key={index} sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <Avatar
            src={item.photoURL ? `${downloadUrl}/${item?.photoURL}` : avatarPlaceholder}
            sx={{ width: 40, height: 40, mr: 1 }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = avatarPlaceholder;
            }}
          />
          <Typography variant="body2" sx={{ color: theme => theme.palette.grey[500] }}>
            {item.displayName || "Anonymous"}
          </Typography>
        </Box>
      ))}

      {/* Collapsible section for remaining items */}
      <Collapse in={expanded}>
        {updatedPermission.slice(visibleItems).map((item, index) => (
          <Box key={index} sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <Avatar
              src={item.photoURL ? `${downloadUrl}/${item?.photoURL}` : avatarPlaceholder}
              sx={{ width: 40, height: 40, mr: 1 }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = avatarPlaceholder;
              }}
            />
            <Typography variant="body2" sx={{ color: theme => theme.palette.grey[500] }}>
              {item.displayName || "Anonymous"}
            </Typography>
          </Box>
        ))}
      </Collapse>

      {/* Toggle button */}
      {updatedPermission.length > visibleItems && (
        <Button
          onClick={() => setExpanded(!expanded)}
          variant="text"
          size="small"
          sx={{ textTransform: "none", mt: 1 }}
        >
          {expanded ? "See Less" : "See More"}
        </Button>
      )}
    </Box> : null
  );
};

export default CollapsiblePermissionList;
